module.exports = __webpack_public_path__ + "static/media/svalbard.44f80005.jpg";